import { css } from "@emotion/react";

export const resetWithPointerStyles = css({
  background: "none",
  border: "none",
  cursor: "pointer",
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const toggleVisibilityButtonStyles = (isOpen: any) =>
  css(resetWithPointerStyles, {
    padding: "0",
    transition: "rotate 0.2s ease-in-out",
    rotate: isOpen ? "90deg" : "0deg",
  });

export const headerStyles = css(resetWithPointerStyles, {
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 16px 0 16px",
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const accordionBodyWrapperStyles = (isOpen: any) =>
  css({
    display: "grid",
    gridTemplateRows: isOpen ? "1fr" : "0fr",
    transition: "grid-template-rows 0.2s ease-in-out",
    overflow: "hidden",
  });

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const accordionBodyStyles = (isOpen: any) =>
  css({
    minHeight: "0px",
    visibility: isOpen ? "visible" : "hidden",
    transition: "visibility 0.2s ease-in-out",
    padding: "0 16px 16px 16px",
  });
